import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_PETITION_PAGE_FULL_SUNRISE = defineFcm('petition_page_full_sunrise')
	.asJson(
		createShapeNormalizer({
			type: 'record',
			// Include any module that will be experimented on in the full sunrise migration
			keys: [
				'actionPanel',
				'contentSummary',
				'dmSection',
				'mediaHits',
				'mediaMentions',
				'membershipAwareness',
				'petitionDescription',
				'supporters',
				'petitionHeading',
				'petitionStarter',
				'petitionUpdates',
				'promotedPetitions',
				'recentSigners',
				'sharePetition',
				'supporterVoices',
				'supporters',
				'reportAbuse',
				'petitionHeader',
			] as const,
			optionalValues: true,
			shape: {
				type: 'object',
				optional: true,
				shape: {
					enabled: { type: 'boolean' },
					experimentName: { type: 'string' },
				},
			},
		}),
	)
	.withDefault({
		actionPanel: { enabled: false, experimentName: '' },
		contentSummary: { enabled: false, experimentName: '' },
		dmSection: { enabled: false, experimentName: '' },
		mediaHits: { enabled: false, experimentName: '' },
		mediaMentions: { enabled: false, experimentName: '' },
		membershipAwareness: { enabled: false, experimentName: '' },
		petitionDescription: { enabled: false, experimentName: '' },
		petitionHeading: { enabled: false, experimentName: '' },
		petitionStarter: { enabled: false, experimentName: '' },
		petitionUpdates: { enabled: false, experimentName: '' },
		promotedPetitions: { enabled: false, experimentName: '' },
		recentSigners: { enabled: false, experimentName: '' },
		sharePetition: { enabled: false, experimentName: '' },
		supporterVoices: { enabled: false, experimentName: '' },
		supporters: { enabled: false, experimentName: '' },
		reportAbuse: { enabled: false, experimentName: '' },
		petitionHeader: { enabled: false, experimentName: '' },
	})
	.toConfig({
		owner: 'squad-vaquita',
		scope: 'corgi-front-end',
		context: 'Petition details',
		description:
			'FC to control the full sunrise migration for the petition page and any related experiments for each module',
		import: false,
		template: {
			petitionDescription: {
				enabled: false,
				experimentName: '',
			},
			supporters: {
				enabled: false,
				experimentName: '',
			},
			recentSigners: {
				enabled: false,
				experimentName: '',
			},
			promotedPetitions: {
				enabled: false,
				experimentName: '',
			},
			contentSummary: {
				enabled: false,
				experimentName: '',
			},
			petitionStarter: {
				enabled: false,
				experimentName: '',
			},
		},
	});
